class ReviewsAnchor extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.link = this.querySelector('a');
    if (!this.link) return;

    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  get widgetSelector() {
    return '.jdgm-rev-widg, .jdgm-review-widget, .jdgm-all-reviews-widget, .jdgm-all-reviews-widget-v2025';
  }

  stickyHeaderHeight() {
    const header = document.querySelector('.main-header');
    if (!header || getComputedStyle(header).position !== 'sticky') return 0;

    return Math.round(header.getBoundingClientRect().height);
  }

  resolveTarget() {
    const href = this.link.getAttribute('href') ?? '';
    const hashTarget = href.length > 1 ? document.getElementById(href.slice(1)) : null;
    if (hashTarget) return hashTarget;

    const widget = document.querySelector(this.widgetSelector);
    return widget?.closest('.shopify-section') ?? widget;
  }

  handleClick(event) {
    const href = this.link.getAttribute('href') ?? '';
    if (href !== '' && !href.startsWith('#')) return;

    const target = this.resolveTarget();
    if (!target) return;

    event.preventDefault();

    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    target.style.scrollMarginTop = `${this.stickyHeaderHeight()}px`;
    target.scrollIntoView({ behavior, block: 'start' });
    this.realign(target, behavior);

    if (target.id) history.replaceState(null, '', `#${target.id}`);
  }

  // Sections above the widget can lazy-load while the page scrolls and push the
  // target further down, so check where it landed and scroll again if needed.
  realign(target, behavior, attempt = 0) {
    window.setTimeout(() => {
      const margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
      const offset = target.getBoundingClientRect().top - margin;
      if (Math.abs(offset) <= 4 || attempt >= 5) return;

      target.scrollIntoView({ behavior, block: 'start' });
      this.realign(target, behavior, attempt + 1);
    }, attempt === 0 ? 900 : 600);
  }
}

if (!customElements.get('reviews-anchor')) {
  customElements.define('reviews-anchor', ReviewsAnchor);
}
